import React from 'react';
import Tabs from '../components/Tabs';

function InterviewTabs() {
  const tabs = [
    {
      label: 'Current',
      to: '/interviews/current',
    },
    {
      label: 'Completed',
      to: '/interviews/completed',
    },
    {
      label: 'Slots',
      to: '/interviews/slots',
    },
  ];
  return (
    <div className="px-[2%] pt-[1%] w-[100%] mr-[3%]">
      <Tabs
        tabs={tabs}
        classes={{
          root: 'rounded font-bold normal-case text-[14px]',
          activeRoute: 'bg-[#4D586A] text-white',
          lastIndex: 'rounded-r-3xl',
          firstIndex: 'rounded-l-3xl',
          container: 'max-w-fit m-auto custom-shadow-24 ',
        }}
      />
    </div>
  );
}

export default InterviewTabs;
